import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  currentMediaContainer: {
    width: 'auto',
    maxWidth: 'auto',
    minWidth: '70%',
    [theme.breakpoints.down('md')]: {
      paddingTop: 'unset'
    }
  },
  currentMediaContainerSmall: {
    width: '100%',
    minWidth: 'unset',
    maxWidth: 'unset'
  },
  paperCurrentMedia: {
    width: 'auto',
    minWidth: 460,
    height: 'auto',
    minHeight: 320,
    padding: '20px 25px',
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  mt_30: {
    marginTop: 30
  },
  mediaItemPanel: {
    minWidth: '180px',
    width: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  mediaItemPanelSmall: {
    maxWidth: 160
  },
  pdfImageContainer: {
    textAlign: 'center'
  },
  pdfIcon: {
    width: 109,
    height: 109,
    marginBottom: 6
  },
  linkIcon: {
    width: 109,
    height: 109,
    marginBottom: 3,
    marginTop: 3
  },
  currentMediaFileName: {
    fontSize: 14
  }
}))
